import type { Component } from 'solid-js'
import type { UserMetricPeriod } from '../../features/dashboard/domain/models/dashboard'
import { ChartLegend, useChartWithLegend, useLegendState } from '../shared/charts'
import {
  getDashboardChartOptions,
  DASHBOARD_LEGEND_ITEMS,
  DASHBOARD_INITIAL_LEGEND_STATE
} from './DashboardLineChart.vm'

interface DashboardLineChartProps {
  periods: UserMetricPeriod[]
}

const DashboardLineChart: Component<DashboardLineChartProps> = (props) => {
  let chartRef: HTMLDivElement | undefined

  const { state: legendState, toggle } = useLegendState(DASHBOARD_INITIAL_LEGEND_STATE)

  useChartWithLegend({
    data: () => props.periods,
    chartRef: () => chartRef,
    legendState,
    buildOptions: (data, legend) => getDashboardChartOptions(data, legend)
  })

  return (
    <div class="rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
      <ChartLegend items={DASHBOARD_LEGEND_ITEMS} activeKeys={legendState()} onToggle={toggle} class="mb-4" />
      <div ref={chartRef} />
    </div>
  )
}

export default DashboardLineChart
